import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexYAxis,
  ApexTooltip,
  ApexFill,
  ApexLegend
} from "ng-apexcharts";


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};


@Component({
  selector: 'app-stackedBarChart',
  templateUrl: './stackedBarChart.component.html',
})
export class AppStackedBarChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);

  @Input() sale: string = ""

  @Input() salesDataGraph: Array<any> = []
  @Input() categories: Array<any> = []
  @Input() data: Array<any> = []
  public chartOptions!: Partial<ChartOptions> | any;

  constructor() {
    this.chartOptions = {
      series: [],
      chart: {
        type: 'bar',
        height: 1000,
        stacked: true
      },
      xaxis: {
        categories: []
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        opacity: 1
      },
      title: {
        text: 'Sales by Category',}
    };
  }

  onclick() {
    console.log("test")
  }
  async ngOnInit(): Promise<any> {

    const categoriesMap = new Map<string, any>(); // Map for dynamic categories
    const uniqueNames: Set<string> = new Set(); // Set to hold unique names

    // Process the data dynamically
    this.data.forEach(item => {
      uniqueNames.add(item.name);
      if (!categoriesMap.has(item.category)) {
        categoriesMap.set(item.category, []);
      }
      // Initialize entries for missing names
      categoriesMap.forEach((value, key) => {
        if (categoriesMap.get(key).length !== uniqueNames.size) {
          categoriesMap.get(key).push(0);
        }
      });
      const categoryData = categoriesMap.get(item.category);
      categoryData[Array.from(uniqueNames).indexOf(item.name)] = item.count;
    });

    // Prepare chart options dynamically
    const series = Array.from(categoriesMap.keys()).map(category => {
      return {
        name: category,
        data: categoriesMap.get(category)
      };
    });

    this.chartOptions = {
      ...this.chartOptions,
      series: series,
      xaxis: {
        categories: Array.from(uniqueNames) // Unique names as x-axis categories
      }
    };

  }

}
